const sale = {
  finishOrder: "Hoàn tất",
  finishedOrder: "Đã hoàn tất",
  unfinishedOrder: "Chưa hoàn tất",
  code: "Mã hóa khách hàng cuối",
  name1: "Tên khách hàng cuối 1",
  name2: "Tên khách hàng cuối 2",
  shortName: "Khách hàng cuối gọi tắt",
  country: "Quốc tịch/Khu vực",
  address: "địa chỉ",
  zipCode: "Mã bưu điện",
  email: "Địa chỉ email",
  contact: "Người liên hệ",
  phone: "điện thoại",
  fax: "fax",
  mobile: "điện thoại di động",
  account1: "Ngân hàng mở tài khoản 1",
  bank1: "Tài khoản ngân hàng số 1",
  swiftCode1: "Mã ngân hàng 1",
  account2: "Mở tài khoản ngân hàng 2",
  bank2: "Tài khoản ngân hàng số 2",
  swiftCode2: "Mã Ngân Hàng 2",
  currency: "tiền tệ",
  saleType: "Kênh bán hàng",
  creditLevel: "Mức tín dụng",
  creditLine: "Hạn mức tín dụng",
  depositRate: "tỷ lệ tiền gửi (%)",
  tradeTerm: "Điều khoản thương mại",
  payMethod: "phương thức thanh toán",
  commissionRate: "tỷ lệ hoa hồng",
  org: "Bộ phận phụ trách",
  billingDays: "Kỳ tài khoản (ngày)",
  principal: "khách hàng",
  relatedDocuments:
    "Thông tin liên quan (hợp đồng/giấy phép kinh doanh/thông tin hóa đơn)",
  documents: "Thông tin liên quan",
  affiliates: "các công ty liên kết",
  customerList: "Danh sách khách hàng cuối",
  addCustomer: "Thêm khách hàng cuối",
  price: "giá",
  shipAddress: "Địa chỉ giao hàng",
  shipAddressBook: "Sổ địa chỉ giao hàng",
  addShipAddress: "Thêm địa chỉ giao hàng",
  shipAddressName: "Tên người nhận",
  plShipAddressName: "Vui lòng nhập tên người nhận",
  shipAddressType: "Loại người nhận",
  defaultAddress: "Địa chỉ mặc định",
  setDefault: "Đặt làm địa chỉ mặc định",
  remark: "Ghi chú",
  bySearchShipAddress: "Tìm theo tên người nhận, địa chỉ hoặc điện thoại",
  plPrice: "Xin vui lòng nhập giá",
  priceMax: "Giá trị tối đa là: {{ num }}",
  priceMin: "Giá trị tối thiểu là: {{ num }}",
  plProductPrice:
    "Vui lòng chọn hàng, nhập tên hàng tồn kho và mã hàng tồn kho để tìm kiếm",
  plCustomer: "Vui lòng chọn Terminal Client",
  addPrice: "Thêm giá sản phẩm",
  customerRequired: "Thông tin khách hàng không được để trống",
  productRequired: "Thông tin sản phẩm không được để trống",
  priceRequired: "Giá không được để trống",
  product: "hàng hóa",
  priceDetail: "thông tin về giá",
  exitsPrice: "Giá của sản phẩm này đã tồn tại",
  productInfo: "Thông tin sản phẩm",
  orderNumber: "Số đơn hàng bán",
  internalNumber: "Số đơn hàng nội bộ",
  receivingUnit: "đơn vị nhận",
  approvalStatus: "Trạng thái phê duyệt",
  customerContact: "Liên hệ khách hàng cuối",
  receivingContact: "nhận liên hệ",
  customerContactPhone: "Điện thoại liên hệ khách hàng cuối",
  receivingContactMobile: "nhận điện thoại di động liên hệ",
  orderType: "Loại bán hàng",
  plOrderType: "Vui lòng chọn loại bán hàng",
  taxRate: "Thuế suất (%)",
  quantity: "số lượng",
  materialStatus: "Trạng thái vật liệu",
  productionStatus: "trạng thái sản xuất",
  shipmentStatus: "trạng thái vận chuyển",
  receivingStatus: "Trạng thái nhận hàng của khách hàng cuối",
  paymentStatus: "Trạng thái thanh toán",
  receivingAddress: "địa chỉ nhận",
  realPrice: "giá thực",
  totalPrice: "Tổng giá",
  revisePrice: "Điều chỉnh giá",
  actualPrice: "giá thực tế",
  orderState: "Trạng thái đơn hàng",
  passed: "đã qua",
  notApproval: "đang chờ phê duyệt",
  plInnerNumber: "Xin vui lòng nhập số đơn hàng nội bộ",
  plReceivingUnit: "Xin vui lòng nhập đơn vị nhận",
  plReceivingContact: "Vui lòng nhập người liên hệ nhận",
  plReceivingContactMobile:
    "Vui lòng nhập số điện thoại di động của người liên hệ nhận",
  plReceivingAddress: "Xin vui lòng nhập địa chỉ nhận",
  orderProduct: "Sản phẩm đặt hàng",
  plMfgr: "Vui lòng nhập số model của công ty",
  plCustomerModel: "Vui lòng nhập mẫu khách hàng cuối",
  plProductName: "Vui lòng nhập tên sản phẩm",
  plReqDeliDate: "Vui lòng chọn thời gian yêu cầu vận chuyển",
  plSmtStartDate: "Vui lòng chọn ngày dự kiến phát hành",
  plPreFinishDate: "Vui lòng chọn ngày hoàn thành dự kiến",
  plUrgencyLevel: "Xin vui lòng nhập mức độ khẩn cấp",
  plSpecialReq: "Xin vui lòng nhập yêu cầu đặc biệt",
  plReRemark: "Xin vui lòng nhập nhận xét",
  plQuantity: "Vui lòng nhập số lượng",
  customerShortName: "Tên viết tắt khách hàng cuối",
  productCode: "Mã hàng tồn kho",
  productName: "Tên sản phẩm",
  productModel: "Mô hình sản phẩm",
  productUom: "Đơn vị đo chính",
  addOrder: "Thêm đơn hàng",
  orderSearchTip:
    "Tìm kiếm theo số đơn đặt hàng Tên khách hàng cuối Mã hàng tồn kho Mô hình khách hàng cuối Mô hình công ty Tên hàng tồn kho Mô hình sản phẩm Mã khách hàng đầu cuối Tên khách hàng đầu cuối Tên khách hàng đầu cuối 1 Tên khách hàng đầu cuối 2",
  innerNumber: "Số nội bộ",
  customerModel: "Mô hình khách hàng cuối",
  mfgr: "Mô hình công ty",
  reRemark: "Ghi chú",
  reqDeliDate: "Thời gian yêu cầu vận chuyển",
  smtStartDate: "Ngày phát hành dự kiến",
  preFinishDate: "Ngày hoàn thành dự kiến",
  urgencyLevel: "khẩn cấp",
  specialReq: "Yêu cầu đặc biệt",
  orderInfo: "Thông tin đặt hàng",
  customerInfo: "Thông tin khách hàng cuối",
  proInfo: "Thông tin sản phẩm",
  reportInfo: "dữ liệu báo cáo",
  saleTotalQuantity: "Tổng số lượng cần sản xuất",
  outPro: "vận chuyển",
  inStock: "Còn hàng",
  dataReportSearch:
    "Tìm kiếm theo số đặt hàng, thông tin khách hàng cuối, thông tin hàng tồn kho Từ khóa",
  notReportData: "Chưa có dữ liệu báo cáo",
  reportSearchTip:
    "Tìm kiếm theo số thứ tự, mã khách hàng cuối, viết tắt của khách hàng cuối, mã hàng tồn kho, tên hàng tồn kho",
  addEdit: "Thêm/Chỉnh sửa dữ liệu sản xuất",
  productionSearchTip:
    "Tìm kiếm theo số thứ tự, mã hàng tồn kho, tên hàng tồn kho và từ khóa thông tin khách hàng cuối",
  exitsData: "Dữ liệu trong ngày đã tồn tại",
  time: "thời gian",
  updateSuccess: "Sửa đổi thành công",
  history: "Chi tiết lịch sử",
  plCode: "Vui lòng nhập mã khách hàng cuối",
  plName1: "Vui lòng nhập tên khách hàng cuối 1",
  plName2: "Vui lòng nhập tên khách hàng cuối 2",
  plShortName: "Vui lòng nhập tên khách hàng cuối",
  plAddress: "Vui lòng nhập địa chỉ khách hàng cuối",
  plZipCode: "Vui lòng nhập mã zip của khách hàng cuối",
  plEmail: "Vui lòng nhập địa chỉ email của khách hàng cuối",
  plContact: "Vui lòng nhập người liên hệ",
  plPhone: "Vui lòng nhập số điện thoại khách hàng cuối",
  plFax: "Vui lòng nhập số fax của khách hàng cuối",
  plMobile: "Vui lòng nhập số điện thoại của khách hàng cuối",
  plBank1: "Vui lòng nhập số tài khoản ngân hàng 1",
  plAccount1: "Vui lòng nhập ngân hàng mở tài khoản 1",
  plSwiftCode1: "Vui lòng nhập mã ngân hàng 1",
  plBank2: "Vui lòng nhập số tài khoản ngân hàng 2",
  plAccount2: "Vui lòng nhập ngân hàng mở tài khoản 2",
  plSwiftCode2: "Vui lòng nhập mã ngân hàng 2",
  plSaleTypes: "Vui lòng chọn hình thức bán hàng",
  plCreditLevels: "Vui lòng chọn mức tín dụng",
  plCreditLine: "Vui lòng nhập hạn mức tín dụng",
  plDepositRate: "Vui lòng nhập tỷ lệ gửi tiền",
  plTradeTerms: "Vui lòng chọn điều kiện giao dịch",
  plPaymentMethod: "Vui lòng chọn phương thức thanh toán",
  plDictCommissionRate: "Vui lòng nhập tỷ lệ hoa hồng",
  plAffiliates: "Vui lòng nhập công ty liên kết",
  plBillingDays: "Xin vui lòng nhập ngày thanh toán",
  plPrincipal: "Xin vui lòng nhập khách hàng",
  plTaxRate: "Vui lòng nhập thuế suất",
  plOrg: "Hãy chọn một tổ chức",
  saleTypeAdd: "Thêm loại hình bán hàng",
  saleTypeDetail: "Chi tiết loại hình bán hàng",
  payAdd: "Thêm phương thức thanh toán",
  payDetail: "Chi tiết phương thức thanh toán",
  tradeAdd: "Thêm điều kiện giao dịch",
  tradeDetail: "Chi tiết điều khoản thương mại",
  codeRequired: "Mã khách hàng cuối Bắt buộc",
  codeExisted: "Mã khách hàng cuối đã tồn tại",
  prevRequired: "Trước tiên hãy hoàn tất việc thêm dữ liệu trước đó",
  bySearchCustomer:
    "Tìm kiếm bằng mã hóa khách hàng cuối Tên khách hàng cuối 1 Tên khách hàng cuối 2 Tên khách hàng cuối",
  bySearch:
    "Tìm kiếm bằng mã hàng tồn kho Tên hàng tồn kho Mã khách hàng đầu cuối Tên khách hàng đầu cuối 1 Tên khách hàng đầu cuối 2 Tên khách hàng đầu cuối Viết tắt địa chỉ",
  bySearchPrice:
    "Tìm kiếm theo mã hàng tồn kho Tên hàng tồn kho Mô hình sản phẩm",
  infoExisted: "Thông tin này đã tồn tại",
  customerNotExist: "Thông tin khách hàng cuối không tồn tại hoặc đã bị xóa",
  estimateDays: "Số ngày dự kiến đến",
  expiredAt: "Thời gian hết hạn",
  plEstimateDays: "Vui lòng điền vào số ngày dự kiến đến",
  plExpiredAt: "Vui lòng chọn thời gian hết hạn",
  shippingMethod: "Phương thức vận chuyển",
  plShipping: "Vui lòng chọn phương thức vận chuyển",
  customerType: "Loại khách hàng cuối",
  plCustomerType: "Vui lòng chọn loại khách hàng cuối",
  productNotExisted: "Vui lòng chọn sản phẩm",
  orderSuccessProjectError:
    "Sửa đổi thông tin đặt hàng thành công, sửa đổi thông tin hàng hóa không thành công",
  projectSuccessOrderError:
    "Sửa đổi thông tin sản phẩm thành công, sửa đổi thông tin đơn hàng không thành công",
  productPre: "Sau khi lựa chọn hàng hóa mới được phê duyệt",
  innerNumberPre: "Điền số nội bộ để được phê duyệt",
  passError: "Phê duyệt không được thông qua",
  passSuccess: "Phê duyệt thông qua",
  orderList: "Danh sách đặt hàng",

  taxPrice: "Đơn giá đã bao gồm thuế",
  plTaxPrice: "Xin vui lòng nhập đơn giá đã bao gồm thuế",

  addRequirement: "Thêm mẫu đánh giá",
  requirement: "Danh sách yêu cầu",

  notRequirement: "Chưa có danh sách yêu cầu nào được tạo",
  orderDate: "Ngày đặt hàng",
  selectColumns: "Chọn các cột xuất",
  editOrder: "Sửa đổi lệnh",
  updateErr: "Sửa đổi thông tin đặt hàng không thành công",
  exportPI: "Xuất mẫu PI",

  aPrice: "Giá điều chỉnh",
  discount: "Ưu đãi/giảm giá",
  sPrice: "Tổng giá bán",
  send: "Chuẩn bị quà tặng",
  sendQuantity: "Số lượng quà tặng",
  sendAPrice: "Giá điều chỉnh quà tặng",
  sendDiscount: "Ưu đãi/giảm giá quà tặng",
  sendPrice: "Tổng giá trị quà tặng",
  orderTotal: "Tổng giá đặt hàng",
  discountHelp:
    "Giá ưu đãi tối đa không được lớn hơn giá bán (không bao gồm hàng dự phòng): {{count}}",

  // Excel导出相关
  quotationSheet: "BÁO GIÁ",
  to: "ĐẾN:",
  mov: "PHƯƠNG THỨC THANH TOÁN:",
  effectiveDate: "NGÀY CÓ HIỆU LỰC:",
  modelNo: "Mô hình",
  mfgrNo: "Mô hình nhà sản xuất",
  picture: "Hình ảnh",
  descriptionOfProduct: "Mô tả sản phẩm",
  chipSet: "Bộ chip",
  package: "Đóng gói (cái/hộp)",
  unitPrice: "Đơn giá",
  note: "LƯU Ý",
  quotationNote1: "1) Báo giá trên dựa trên thanh toán 100% trước khi giao hàng.",
  quotationNote2: "2) Nếu giá trị đơn hàng dưới 40.000 USD, điều kiện giá sẽ là EX-WORK",
  quotationNote3: "3) Hiệu lực báo giá: 2 TUẦN từ hôm nay.",
  quotationNote4: "4) Xác nhận đơn hàng bằng tiền cọc (đặt cọc)",
  exportFailed: "Xuất không thành công:",
  quotationTitle: "BÁO GIÁ",
  contactPerson: "Người liên hệ:",
  officeTel: "Điện thoại văn phòng:",
  emailLabel: "E-mail:",
  date: "Ngày:",
  quotationNumber: "Số báo giá:",
  respectedCustomer: "Kính gửi Quý khách hàng",
  quotationIntro: "Cảm ơn Quý khách hàng quan tâm đến nhà máy ZIONCOM Việt Nam. Dựa trên thông tin Quý khách cung cấp và nhu cầu hợp tác trực tiếp với chúng tôi, chúng tôi rất vui mừng được cung cấp phương án dịch vụ và báo giá liên quan để Quý khách tham khảo.",
  no: "STT",
  quotationProductCode: "Mã hàng",
  quotationProductDesc: "Mô tả hàng hóa",
  quotationUnit: "Đơn vị",
  quotationCurrency: "Tiền tệ",
  moqPrice: "MOQ/ Giá mua (Chưa thuế)",
  attention: "Lưu ý:",
  quotationAttention1: "1. Báo giá bao gồm: chi phí nhân công, hàn keo và vận chuyển đến VSIP II, Tỉnh Bình Dương.",
  quotationAttention2: "2. Báo giá không bao gồm: nguyên vật liệu và VAT.",
  quotationAttention3: "3. Điều khoản thanh toán: Thanh toán phải được thực hiện trong vòng 30 ngày sau khi thanh toán hàng tháng.",
  quotationAttention4: "4. Số lượng đặt hàng tối thiểu (MOQ): Nếu dưới MOQ 1000 cái, phí khuôn mẫu 2.720.000 VND/đơn hàng sẽ được tính cho mỗi đơn hàng",
  customerConfirmation: "Xác nhận của khách hàng",
  zioncomVietnam: "Zioncom (Vietnam) Jsc",
  inquiryTemplate: "Mẫu báo giá",
  quotationTemplate: "Mẫu báo giá",
  transferOrder: "Thông tin chuyển đơn hàng",
  customerPriceTemplate: "Mẫu giá khách hàng",
  importCustomerPrice: "Nhập giá khách hàng",
  swapRes: "Kết quả chuyển đơn",
  originSale: "Đơn bán hàng gốc",
  orderNo: "Số đơn hàng",
  prodOrderNo: "Số đơn sản xuất",
  oldCode: "Mã vật liệu cũ",
  prodCode: "Mã sản phẩm",
  prodName: "Tên sản phẩm",
  prodMod: "Quy cách/Mẫu mã",
  count: "Số lượng",
  uom: "ĐVT",
  batch: "Số lô",
  origin: "Bộ phận",
  productor: "Nhân viên vật tư",
  confirmer: "Xác nhận chất lượng",
  prodManager: "Quản lý sản xuất",
  warehouseer: "Thủ kho",
  approver: "Người duyệt",
  checker: "Người phê chuẩn",
  inboundNo: "Số đơn nhập kho",
  inboundDate: "Ngày nhập kho",
  warehouse: "Kho",
  finishedWarehouse: "Kho thành phẩm",
  inboundType: "Loại nhập kho",
  prodIn: "Đơn nhập kho thành phẩm",
  littleTotal: "Tạm tính",
  total: "Tổng cộng",
  saleSwap: "Chuyển thành đơn bán hàng",
  purSwap: "Chuyển thành đơn mua hàng",
  notApi: "Khách hàng này chưa cấu hình WmsApi, không thể chuyển đơn!",
  notSale: "Sản phẩm trong đơn bán hàng này không đáp ứng điều kiện chạy đơn nhu cầu, không thể chuyển đơn!",
  purchaseData: "Dữ liệu mua hàng",
  confirmGeneratePurOrder: "Xác nhận tạo đơn mua hàng?",
  notCusPros: "Các vật liệu này không tồn tại trong hệ thống WMS của khách hàng. Vui lòng duy trì dữ liệu vật liệu này trong hệ thống WMS của khách hàng trước.",
  notPurProPrice: "Thông tin giá mua hàng từ nhà cung cấp này cho các vật liệu này không tồn tại trong hệ thống WMS của khách hàng. Vui lòng duy trì thông tin giá mua hàng liên quan trong hệ thống WMS của khách hàng trước.",
  purSucc: "Đơn mua hàng được tạo thành công",
  onlyOneCustomer: "Chỉ cho phép chọn đơn bán hàng của cùng một khách hàng!",
  editOutPl: "Số lượng xuất kho khả dụng đã được cập nhật. Vui lòng sửa số lượng xuất kho.",
  bomCopyTip: "Đơn bán hàng này có tệp đính kèm BOM. Bạn có muốn sao chép tệp đính kèm BOM sang đơn hàng mới không?",
  bomCopyYes: "Sao chép đơn bán hàng và tệp đính kèm BOM",
  bomCopyCancel: "Chỉ sao chép đơn bán hàng",
  receiverFax: "Fax người nhận",
  receiverPhone: "Điện thoại người nhận",
  licenseId: "Giấy phép đăng ký kinh doanh",
  licenseAddress: "Địa chỉ đăng ký kinh doanh",
  invoiceNumber: "Số hóa đơn",
  invoiceAddress: "Địa chỉ gửi hóa đơn",
  printDate: "Ngày lập",
  printPageNo: "Trang",
  domesticSaleOrder: "Đơn bán hàng nội địa",
  printSaleNo: "Số đơn bán",
  printCustomerName: "Tên đầy đủ khách hàng",
  printUnifiedTitle: "Giấy phép đăng ký kinh doanh",
  printOrderDate: "Ngày đơn",
  printSendAddress: "Địa chỉ giao hàng",
  printPhone: "Số điện thoại",
  printInvoiceNumber: "Số hóa đơn",
  printInvoiceAddress: "Địa chỉ hóa đơn",
  printContact: "Người liên hệ",
  printRemark: "Ghi chú",
  printSeq: "STT",
  printProductName: "Tên hàng",
  printQuantity: "SL bán",
  printBQuantity: "SL tặng/dự phòng",
  printUom: "ĐVT",
  printPrice: "Đơn giá",
  printAmount: "Thành tiền",
  onlyOneSelectip: "Vui lòng chọn một chứng từ",
  printSale: "In phiếu bán hàng",
  printTotalQuantity: "Tổng số lượng",
  printSaleAmount: "Giá trị bán (nội tệ)",
  printSaleTax: "Thuế bán (nội tệ)",
  printTotalAmount: "Tổng tiền (nội tệ)",
  orderPrintLeft: "Sau khi ký nhận, vui lòng gửi lại hoặc fax về: {{fax}}. Xin cảm ơn!!",
  orderPrintRight: "Liệu tự lưu (Trắng) - Kế toán (Xanh) - Ký nhận (Đỏ) - Khách hàng (Vàng)",
  printApprove: "Phê duyệt",
  printWarehouse: "Kho",
  printSales: "Kinh doanh",
  printMaker: "Người lập",
  printCustomerSign: "Khách ký nhận",
  toOfficial: "Chuyển thành đơn chính thức",
  toOfficialConfirm: "Bạn có chắc muốn chuyển {{count}} đơn đã chọn thành đơn chính thức?",
  toOfficialSingleConfirm: "Bạn có chắc muốn chuyển thành đơn chính thức?",
  toOfficialSuccess: "Chuyển thành đơn chính thức thành công",
  toOfficialError: "Các đơn sau chuyển thành đơn chính thức thất bại",
  toOfficialHasRequirement: "Các đơn sau đã có danh sách nhu cầu, không thể chuyển thành đơn chính thức",
};

export default sale;
